// Utility function to remove soft hyphen characters from strings in objects
export const removeSoftHyphens = (data: any): any => {
  if (!data) return data;

  if (typeof data === 'string') {
    // Remove soft hyphens (Unicode U+00AD or HTML entity &shy;)
    return data.replace(/\u00AD|&shy;|&#173;/gi, '');
  }

  if (Array.isArray(data)) {
    return data.map(item => removeSoftHyphens(item));
  }

  if (typeof data === 'object') {
    const cleanedData: any = {};
    Object.keys(data).forEach(key => {
      cleanedData[key] = removeSoftHyphens(data[key]);
    });
    return cleanedData;
  }

  return data;
};
